import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BooksMobileFilterListWrapper } from "@/components/Books/List/BookListMobileFilterList";
import SelectedFilterWrapper from "@/components/Categories/Menu/SelectedFilter";
import { MobileSliderArea } from "@/components/Search";
import { MobileFilterListItem } from "@/components/Search/MobileFilterListItem";
import { MobileFilterSideSheet } from "@/components/Search/MobileFilterSideSheet";
import { FilterQueryHandlerType, useCategoryFilterHandler } from "@/hooks/useCategoryFilterHandler";
import { SearchQueryKey } from "src/api/search";
import { routerOptions } from "../Search/useSearchBarHandler";
import useSearchParamHandler from "../useSearchParamHandler";
{
/* 브랜드 카테고리 필터의 경우, 모바일 사이즈에서는  사이드시트 */ }const BrandCategoryFilter = (param)=>{
    let { open , openFilter , filterItems  } = param;
    const { selectedFilterList , addLabelSelectedTicket  } = useSearchParamHandler();
    const { filterQueryHandler  } = useCategoryFilterHandler({
        isUseAsPath: true,
        routerOptions: routerOptions
    });
    var _addLabelSelectedTicket, _addLabelSelectedTicket1;
    return /*#__PURE__*/ _jsx(MobileSliderArea, {
        children: /*#__PURE__*/ _jsxs(MobileFilterSideSheet, {
            title: "상세 필터",
            sliderOpen: open,
            openSlider: openFilter,
            children: [
                ((_addLabelSelectedTicket = addLabelSelectedTicket(filterItems)) !== null && _addLabelSelectedTicket !== void 0 ? _addLabelSelectedTicket : []).length > 0 && /*#__PURE__*/ _jsx(SelectedFilterWrapper, {
                    position: "sideSheet",
                    button: /*#__PURE__*/ _jsx(SelectedFilterWrapper.ResetButton, {
                        handleResetFilter: ()=>filterQueryHandler({
                                filterType: FilterQueryHandlerType.RESET
                            })
                    }),
                    children: ((_addLabelSelectedTicket1 = addLabelSelectedTicket(filterItems)) !== null && _addLabelSelectedTicket1 !== void 0 ? _addLabelSelectedTicket1 : []).map((item, idx)=>{
                        return /*#__PURE__*/ _jsx(SelectedFilterWrapper.SelectedItem, {
                            label: item.label,
                            onRemove: ()=>filterQueryHandler({
                                    filterType: FilterQueryHandlerType.DETAILFILTER,
                                    filterName: item.key,
                                    value: item.value
                                })
                        }, "selectedItem" + idx);
                    })
                }),
                /*#__PURE__*/ _jsx(BooksMobileFilterListWrapper, {
                    children: /*#__PURE__*/ _jsx("ul", {
                        children: filterItems.map((filter, idx)=>{
                            const newFilters = filter.items.map((item)=>{
                                if (filter.key === SearchQueryKey.TICKETS) {
                                    return {
                                        id: filter.key,
                                        value: item.id,
                                        label: item.value
                                    };
                                }
                                return {
                                    id: filter.key,
                                    value: item,
                                    label: item
                                };
                            });
                            if (filter.items.length > 0) return /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(MobileFilterListItem, {
                                    title: filter.key,
                                    filterItem: newFilters,
                                    handleFilter: (filterType, id, value)=>{
                                        filterQueryHandler({
                                            filterType: FilterQueryHandlerType.DETAILFILTER,
                                            filterName: filterType,
                                            value: value
                                        });
                                    },
                                    selectedFilters: addLabelSelectedTicket(filterItems),
                                    openSlider: openFilter,
                                    sliderOpen: open
                                })
                            }, idx);
                        })
                    })
                })
            ]
        })
    });
};
export default BrandCategoryFilter;
